import React, {useRef} from 'react';
import Styles from './index.module.scss';
import TableRender, {ProColumnsType, TableContext} from 'table-render';
import {
    getTenantServiceHistoryList,
    ServiceHistoryList,
} from '../../../service';
import useModalHandler from '../../../../../../Utils/Hooks/useModalHandler';
import DefaultServiceModal from './Components/DefaultServiceModal';
import useTable from '../../../../../../Utils/Hooks/useTable';
import {useDict} from '../../../dict';
import Style from './index.module.scss';
import {Button, Space, Tag} from 'antd';

interface Props {
    customerId: string;
    onReload: () => void;
}
const Index = ({customerId, onReload}: Props) => {
    const dict = useDict();
    const {tableInit} = useTable(
        e => getTenantServiceHistoryList({...e, customerId}),
        {pageSize: 999},
    );
    const tableRef = useRef<TableContext>(null);
    const defaultServiceModal = useModalHandler({
        component: DefaultServiceModal,
    });
    async function reload(stay = true) {
        await tableRef?.current?.refresh({stay});
        await onReload();
    }

    const columns: ProColumnsType<ServiceHistoryList> = [
        {title: '序号', render: (_, _item, index) => index + 1, width: 80},
        {title: '订购编号', dataIndex: 'orderNumber', width: 300},
        {title: '方案名称', dataIndex: 'name', width: 120},
        {
            title: '方案类型',
            dataIndex: 'type',
            width: 120,
            render: dict.ScenarioType.getName,
        },
        {
            title: '服务范围',
            dataIndex: 'serviceList',
            render: (name, item) => (
                <div>
                    {item.serviceList.map(tag => (
                        <Tag key={tag.id}>{tag.name}</Tag>
                    ))}
                </div>
            ),
        },
        {title: '创建人', dataIndex: 'createUser', width: 120},
        {
            title: '服务期限',
            dataIndex: 'expireType',
            width: 120,
            render: dict.ServiceTime.getName,
        },
        {
            title: '状态',
            dataIndex: 'serviceStatus',
            width: 120,
            render: dict.ServiceStatus.getName,
        },
        {
            title: '有效期',
            width: 300,
            render: (name, item) => (
                <div>
                    {item.expirationStartTime} - {item.expirationEndTime}
                </div>
            ),
        },
        {
            title: '操作',
            dataIndex: 'id',
            align: 'center',
            fixed: 'right',
            render: (id: string, item) => (
                <Button
                    size="small"
                    type="link"
                    onClick={() =>
                        defaultServiceModal.open({
                            customerId,
                            id,
                            onOk: onBuyOk,
                        })
                    }>
                    编辑
                </Button>
            ),
        },
    ];

    function onBuyOk() {
        defaultServiceModal.close();
        reload(false);
    }
    const toolBar = (
        <div className={Style.toolBar}>
            <Space>
                <Button
                    type="primary"
                    onClick={() =>
                        defaultServiceModal.open({
                            customerId,
                            onOk: onBuyOk,
                        })
                    }>
                    购买服务
                </Button>
            </Space>
        </div>
    );
    return (
        <div className={Styles.root}>
            {toolBar}
            <TableRender
                bordered
                pageChangeWithRequest={false}
                rowKey="id"
                ref={tableRef}
                columns={columns}
                scroll={{x: 'max-content'}}
                {...tableInit()}
            />
            {defaultServiceModal.render()}
        </div>
    );
};

export default Index;
